import * as localForage from 'localforage';
import { isEqual } from 'lodash-es';
const MAX_VISITED_URL = 5;

export interface VisitedUrl {
  title: string;
  url: string;
  queryParams?: {};
}

interface User {
  userId: number;
  orgId: number;
}
export class RouteEventsStorageHelper {
  static setLocalForageItem(urlVal: VisitedUrl, currentUser: User) {
    const forageId = this.getForageId(currentUser) + '-recentLink';
    this.getLocalForageItem(currentUser)
      .then((recentUrls) => {
        return localForage.setItem(
          forageId,
          this.insertAtTop(urlVal, recentUrls),
        );
      })
      .catch((err) => {
        throw new Error('An error ocurred loading recent links.');
      });
  }
  static getForageId(currentUser: User) {
    return `${currentUser.userId}-${currentUser.orgId}`;
  }
  static getLocalForageItem(currentUser: User) {
    const forageId = this.getForageId(currentUser) + '-recentLink';
    return localForage.getItem(forageId) as Promise<
      VisitedUrl[] | null | undefined
    >;
  }
  static insertAtTop(
    urlValue: VisitedUrl,
    list: VisitedUrl[] | null | undefined,
  ) {
    if (list && Array.isArray(list)) {
      const newList = list.slice();
      const index = newList.findIndex((urlVal: VisitedUrl) => {
        return (
          urlValue.url === urlVal.url &&
          isEqual(urlValue.queryParams, urlVal.queryParams)
        );
      });
      if (index !== -1) {
        newList.splice(index, 1);
      }
      newList.unshift(urlValue);
      return newList.length > MAX_VISITED_URL
        ? newList.slice(0, MAX_VISITED_URL)
        : newList;
    } else {
      return [urlValue];
    }
  }
}
